import Modal from "../../../../components/Modal/Modal";
import React from "react";
import { useApp } from "../../../../contexts";
import { Divider } from "antd";

export const ModalCreateWalletSuccess = (props) => {
  const {
    T
  } = useApp();
  
  const onClose = () => {
    props.onClose();
  };
  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2
        width="750px"
        onClose={onClose}
        className={"!xls:rouded-[64px]"}
      >
        <div className="py-[10px] xls:py-0">
          <div className="text-aia-red text-center font-medium text-[18px] lg:text-[20px] xls:text-[30px] tracking-[-0.96px]">
            {T('Created web3 wallet successfully')}
          </div>
          <div className=" text-black mx-auto text-[16px] font-medium">
            <div className="mb-[30px] mt-[34px]">
              <div className="text-black font-[400] mb-[10px] text-[15px] lg:text-[15px] xls:text-[16px]" 
              dangerouslySetInnerHTML={{
                __html: T("Your web3 wallet has been created successfully. Please access your web3 wallet on AI Avatar app. Now you can transfer ETH from AMS to web3 wallet."),
              }}>
              </div>
            </div>
          </div>
          <Divider style={{ marginTop: 40, marginBottom: 20 }} />
          <div className="flex gap-3 md:gap-[20px] justify-center flex-col md:flex-row items-center mt-[40px]">
            <button
              onClick={() => props?.onSubmit()}
              className="rounded-[14px] border border-solid px-[16px] py-[9px] bg-[#000] text-[#fff] text-center text-[14px] md:text-[16px]"
            >
              {T("Transfer To Web3 Request")}
            </button>
          </div>
        </div>
      </Modal.Container2>
    </Modal>
  );
};
